import { api } from './api';

// Admin-only live status of the micast-api worker pool. Used by the
// WorkerStatusPanel that pops in on /elements while a media conversion
// is in flight. Polling is driven by the caller via the hook option
// `pollingInterval` — keep this endpoint lightweight (Redis-only reads)
// so a 2–3s cadence is not a load issue.
export const workerStatusApi = api.injectEndpoints({
  endpoints: (build) => ({
    getWorkerStatus: build.query({
      query: () => ({ url: 'admin/worker-status' }),
      transformResponse: (response) => response?.data || { running: [], queued: [] },
    }),
  }),
});

export const { useGetWorkerStatusQuery } = workerStatusApi;
